// Natural (numeric-aware) ordering for material display titles.
// Mirror of backend/utilities/sorting.js — keep the two in sync.
//
// Locale is hardcoded to "bg" rather than navigator.language: the two
// comparators must agree, and the UI is Bulgarian-only.
const nameCollator = new Intl.Collator("bg", { numeric: true });

export function compareMaterialsByName(a, b) {
  const byName = nameCollator.compare(a?.material_name ?? "", b?.material_name ?? "");
  if (byName !== 0) return byName;

  // Tie-break on id so the order is total. Guarded because not every endpoint
  // selects material_id, and a NaN comparator result is implementation-defined.
  const idA = a?.material_id, idB = b?.material_id;
  if (typeof idA === "number" && typeof idB === "number") return idA - idB;
  return 0;
}

// Returns a sorted copy — never sorts in place. Arrays coming out of the redux
// store are Immer-frozen, so a mutating sort would throw.
export function sortMaterialsByName(rows) {
  return Array.isArray(rows) ? [...rows].sort(compareMaterialsByName) : rows;
}

// For plain string lists (chart category axis).
export function compareNames(a, b) {
  return nameCollator.compare(a ?? "", b ?? "");
}
